import React from "react";

// Pure — reproduces getInjuryTooltip's JSX. `injuries` carry a precomputed dayNumber.
export const InjuryTooltip = ({ injuries, uniqueKey = "", isModal = false }) => {
    if (!injuries || injuries.length === 0) return null;
    return (
        <>
            <span style={{ fontWeight: "bold" }}> Injuries: </span> <br />
            {injuries.map((injury, idx) => (
                <div key={`${uniqueKey}_Injury_${idx}`}>
                    <p style={{ marginBottom: "0px" }}>Type: {injury.injury_type}</p>
                    <p style={{ marginBottom: "0px" }}>Location: {injury.injury_location}</p>
                    <p style={{ marginBottom: "0px" }}>Start Date: {injury.injury_start_date}</p>
                    <p style={{ marginBottom: "0px" }}>Injury Day: {injury.dayNumber}</p>
                    {!isModal && injuries.length !== idx + 1 && <hr style={{ borderTopColor: "white" }} />}
                    {isModal && <br />}
                </div>
            ))}
            {isModal && <br />}
        </>
    );
};
